import { DatabaseModel, DatabaseModelElement } from "./DatabaseModel";
import { GridLegacy } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import React from "react";
// @ts-ignore
import { Link } from "react-router";
import Invoice from "./Invoice";

export enum Type {
  INVOICE = "INVOICE",
  COMMISSION = "COMMISSION",
}

export enum Status {
  CONCEPT = "CONCEPT",
  SENT = "SENT",
  PAID = "PAID",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  CREDITED = "CREDITED",
  CANCELED = "CANCELED",
}

export default class InvoiceLine extends DatabaseModel implements DatabaseModelElement {
  static modelName = "subsInvoiceLine";
  constructor(
    public id: number = 0,

    public subs_invoice_id: number | null = null,
    public subs_subscription_id: number | null = null,
    public status: string | null = null,
    public number: number | null = null,
    public number_suffix: string | null = null,
    public description: string | null = null,
    public unit_price: number | null = null,
    public amount_excl: number | null = null,
    public amount_incl: number | null = null,
    public discount_amount_excl: number | null = null,
    public discount_amount_incl: number | null = null,
    public tax_rate: number | null = null,

    public start_date: Date | null = null,
    public start_date_unix: number | null = null,
    public end_date: Date | null = null,
    public end_date_unix: number | null = null,

    public created_at: Date = new Date(),
    public updated_at: Date = new Date(),
    public deleted_at: Date | null = null,

    public subsInvoice: Invoice | null = null
  ) {
    super();
  }

  static CreateModel(model: any): InvoiceLine {
    return new InvoiceLine(
      model.id,
      model.subs_invoice_id,
      model.subs_subscription_id,
      model.status,
      model.number,
      model.number_suffix,
      model.description,
      model.unit_price,
      model.amount_excl,
      model.amount_incl,
      model.discount_amount_excl,
      model.discount_amount_incl,
      model.tax_rate,
      new Date(model.start_date),
      model.start_date_unix,
      new Date(model.end_date),
      model.end_date_unix,
      new Date(model.created_at),
      new Date(model.updated_at),
      model.deleted_at ? new Date(model.deleted_at) : null,
      model.subs_invoice ? Invoice.CreateModel(model.subs_invoice) : null
    );
  }

  tableRow() {
    return (
      <>
        <GridLegacy item xs={6}>
          {this.description}
        </GridLegacy>
        <GridLegacy item xs={6}>
          <Link to={{ pathname: InvoiceLine.editPath(this.id) }}>
            <Visibility />
          </Link>
        </GridLegacy>
      </>
    );
  }
}
